<template>
  <div>
    <h1 class="text-3xl font-bold text-blue-800">Centre de santé</h1>

    <div class="grid filter-container p-4 m-4" style="justify-content: space-evenly;">
      <div class="col-auto">
        <p-select 
          label="Mairie" 
          optionLabel="text" 
          placeholder="Sélectionnez une mairie"
        />
      </div>
      <div class="col-auto">
        <label for="searchHealthCenter" class="block mb-1">Recherche par Nom</label>
        <p-input 
          id="searchHealthCenter" 
          v-model="searchQuery" 
          placeholder="Rechercher un centre de santé" 
        />
      </div>
      <div class="col-auto">
        <p-select
          label="Période"
          optionLabel="text"
          placeholder="Sélectionnez une période"
          :options="filterOptions"
          v-model="selectedFilter"
          optionValue="value"
          :showClear="true"
        />
      </div>
      <div v-if="selectedFilter === 'custom'" class="grid custom-filter-container p-4">
        <div class="col-auto mr-3">
          <p-calendar 
            v-model="startDate" 
            label="Date de début" 
            placeholder="Date de début" 
            dateFormat="dd/mm/yy" 
          />
        </div>
        <div class="col-auto mr-3">
          <p-calendar 
            v-model="endDate" 
            label="Date de fin" 
            placeholder="Date de fin" 
            dateFormat="dd/mm/yy" 
          />
        </div>
        <button @click="applyCustomFilter" class="p-button p-button-sm">Valider</button>
      </div>
    </div>
    <div class="p-4">
      <DataTable :value="filteredHealthCenters" paginator :rows="10" class="p-datatable-sm" responsiveLayout="scroll" v-if="filteredHealthCenters.length">
        <Column field="name" header="Centre de santé" style="width: 50%"></Column>
        <Column field="births" header="Naissances" style="width: 25%"></Column>
        <Column field="deaths" header="Décès" style="width: 25%"></Column>
      </DataTable>
      <p v-else>Aucune donnée disponible pour le moment.</p>
    </div>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import PSelect from "@/components/form/form-select/p-select.vue";
import PCalendar from "primevue/calendar";
import PInput from "primevue/inputtext";
import { defineComponent, computed, onMounted, ref, watch } from "vue";
import { useHealthCenterList } from "@/store/health-center";

export default defineComponent({
  name: "healthCenterPage",
  components: {
    DataTable,
    Column,
    PSelect,
    PCalendar,
    PInput,
  },
  setup() {
    const healthCenterStore = useHealthCenterList();
    const selectedFilter = ref(null);
    const startDate = ref("");
    const endDate = ref("");
    const searchQuery = ref("");

    const filterOptions = ref([
      { text: "Mois dernier", value: "lastMonth" },
      { text: "Dernier trimestre", value: "lastQuarter" },
      { text: "Dernier semestre", value: "lastSemester" },
      { text: 'Année en cours', value: 'CurrentYear' },
      { text: 'Année en précédente', value: 'PreviousYear' },
      { text: "Personnalisé", value: "custom" },
    ]);

    onMounted(async () => {
      await healthCenterStore.loadAllData();
    });

    watch(selectedFilter, async (newFilter) => {
      if (!newFilter) {
        healthCenterStore.resetData();
      } else if (newFilter === "lastMonth") {
        await healthCenterStore.filterLastMonth();
      } else if (newFilter === "lastQuarter") {
        await healthCenterStore.filterLastQuarter();
      } else if (newFilter === "lastSemester") {
        await healthCenterStore.filterLastSemester();
      } else if (newFilter === "CurrentYear") {
        await healthCenterStore.filterCurrentYear();
      } else if (newFilter === "PreviousYear") {
        await healthCenterStore.filterPreviousYear();
      }
    });

    const applyCustomFilter = async () => {
      await healthCenterStore.applyDateFilter(startDate.value, endDate.value);
    };

    const healthCenters = computed(() => healthCenterStore.healthCenters);
    
    const filteredHealthCenters = computed(() => {
      if (!searchQuery.value) {
        return healthCenters.value;
      }
      const query = searchQuery.value.toLowerCase();
      return healthCenters.value.filter((center) =>
        center.name.toLowerCase().includes(query)
      );
    });

    return {
      filteredHealthCenters,
      selectedFilter,
      startDate,
      endDate,
      filterOptions,
      searchQuery,
      applyCustomFilter,
    };
  },
});
</script>

<style lang="scss" src="./health-center-page.scss" scoped />
